<div class="tabla-container">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="loading-overlay">
    <div class="spinner"></div>
  </div>

  <!-- Buscador -->
  <div class="search-container" [class.hidden-on-loading]="isLoading">
    <svg
      class="search-icon"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
    <input
      type="text"
      class="search-input"
      placeholder="Search by Project Name or Technology"
      [(ngModel)]="searchTerm"
      (input)="onSearch()"
    />
  </div>

  <table class="tech-stack-table" [class.hidden-on-loading]="isLoading">
    <thead>
      <tr>
        <th>Project Name</th>
        <th>Technology</th>
        <th>Current Version</th>
        <th>End Of Life</th>
        <th>Status</th>
        <th>Recommended Version</th>
        <th>Status +1 Year</th>
        <th *ngIf="false">Prod Certificates</th>
        <th *ngIf="false">Prod Certificate Date</th>
        <th>Comments</th>
      </tr>
    </thead>
    <tbody>
      <ng-container>
        <!-- Mensaje cuando no hay resultados -->
        <tr
          *ngIf="filteredRepositories.length === 0 && searchTerm"
          class="no-results"
        >
          <td colspan="10" class="no-results-message">
            No projects found matching "{{ searchTerm }}"
          </td>
        </tr>

        <!-- Filas de datos -->
        <ng-container
          *ngFor="let row of filteredRepositories; let rowIndex = index"
        >
          <!-- Calculamos el número total de tecnologías para rowspan -->
          <ng-container *ngIf="getTotalTechnologies(row) as totalTechs">
            <ng-container
              *ngFor="
                let tech of getAllTechnologies(row);
                let techIndex = index
              "
            >
              <tr
                (mouseenter)="onRowHover(rowIndex, techIndex, true)"
                (mouseleave)="onRowHover(rowIndex, techIndex, false)"
              >
                <!-- Project Name - solo en la primera fila -->
                <td
                  *ngIf="techIndex === 0"
                  class="project-name"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  <button
                    class="project-link"
                    (click)="navigateToProject(row.project)"
                    title="View project details"
                  >
                    {{ row.project | titleFormat }}
                  </button>
                  <div class="project-type">
                    <div class="icon-with-tooltip">
                      <img
                        src="../../../../../../assets/icons/{{ row.type }}.svg"
                        alt="{{ row.type }}"
                        class="project-type-icon"
                      />
                      <span class="tooltip-text">{{
                        row.type | titleFormat
                      }}</span>
                    </div>
                  </div>
                </td>

                <!-- Technology -->
                <td class="technology-cell">
                  {{ tech.tech | titleFormat }}
                </td>

                <!-- Current Version -->
                <td class="version-cell">
                  {{ tech.cleaned_version }}
                </td>

                <!-- End Of Life -->
                <td class="eol-cell">
                  {{
                    formatEolDate(tech.eol)
                      ? (formatEolDate(tech.eol)! | dateFormat)
                      : "No date"
                  }}
                </td>

                <!-- Status -->
                <td class="status-cell">
                  <div class="icon-with-tooltip">
                    <div
                      class="status-indicator"
                      [ngClass]="calculateTechStatus(tech, tech.tech)"
                    >
                      <span class="status-dot"></span>
                    </div>
                    <span
                      class="tooltip-text"
                      [ngClass]="{
                        'tooltip-good':
                          calculateTechStatus(tech, tech.tech) ===
                          'status-green',
                        'tooltip-danger':
                          calculateTechStatus(tech, tech.tech) === 'status-red',
                        'tooltip-caution':
                          calculateTechStatus(tech, tech.tech) ===
                          'status-orange',
                        'tooltip-gray':
                          calculateTechStatus(tech, tech.tech) === 'status-gray'
                      }"
                    >
                      {{
                        calculateTechStatus(tech, tech.tech) === "status-green"
                          ? "Active Support"
                          : calculateTechStatus(tech, tech.tech) ===
                            "status-red"
                          ? "No Support"
                          : calculateTechStatus(tech, tech.tech) ===
                            "status-gray"
                          ? "No info"
                          : "Security Support"
                      }}
                    </span>
                  </div>
                </td>

                <!-- Recommended Version -->
                <td class="recommended-cell">
                  {{ getRecommendedVersion(tech.tech, tech.cleaned_version) }}
                </td>

                <!-- Status +1 Year -->
                <td class="status-year-cell">
                  <div class="icon-with-tooltip">
                    <div
                      class="status-indicator"
                      [ngClass]="calculateTechStatus(tech, tech.tech, 1)"
                    >
                      <span class="status-dot"></span>
                    </div>
                    <span
                      class="tooltip-text"
                      [ngClass]="{
                        'tooltip-good':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-green',
                        'tooltip-danger':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-red',
                        'tooltip-caution':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-orange',
                        'tooltip-gray':
                          calculateTechStatus(tech, tech.tech, 1) ===
                          'status-gray'
                      }"
                    >
                      {{
                        calculateTechStatus(tech, tech.tech, 1) ===
                        "status-green"
                          ? "Active Security"
                          : calculateTechStatus(tech, tech.tech, 1) ===
                            "status-red"
                          ? "No Support"
                          : calculateTechStatus(tech, tech.tech, 1) ===
                            "status-gray"
                          ? "No info"
                          : "Security Support"
                      }}
                    </span>
                  </div>
                </td>

                <!-- Prod Certificates - solo en la primera fila -->
                <td
                  *ngIf="false"
                  class="prod-certificates"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  Azure
                </td>

                <!-- Prod Certificate Date - solo en la primera fila -->
                <td
                  *ngIf="false"
                  class="prod-certificate-date"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  16/Nov/2120
                </td>

                <!-- Comments - solo en la primera fila -->
                <td
                  *ngIf="techIndex === 0"
                  class="comments"
                  [attr.rowspan]="totalTechs"
                  [class.cell-hover]="isProjectColumnHovered(rowIndex)"
                >
                  <div class="comments-buttons">
                    <button
                      class="btn-view"
                      (click)="viewComments(row.project)"
                    >
                      View
                    </button>
                    <button
                      class="btn-add"
                      (click)="openCommentModal(row.project)"
                    >
                      Add
                    </button>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </tbody>
  </table>

  <!-- Modal para agregar comentarios -->
  <div
    class="comment-modal-overlay"
    *ngIf="isModalOpen"
    (click)="closeCommentModal()"
  >
    <div class="comment-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Add Comment for {{ selectedProject }}</h3>
        <button class="close-btn" (click)="closeCommentModal()">&times;</button>
      </div>
      <div class="modal-body">
        <div class="editor-toolbar">
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('bold')"
            title="Bold"
          >
            <strong>B</strong>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('italic')"
            title="Italic"
          >
            <em>I</em>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('underline')"
            title="Underline"
          >
            <u>U</u>
          </button>
          <div class="toolbar-separator"></div>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('insertUnorderedList')"
            title="Bullet List"
          >
            ☰
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="formatText('insertOrderedList')"
            title="Numbered List"
          >
            ≡
          </button>
        </div>
        <div
          class="rich-text-editor"
          contenteditable="true"
          #richTextEditor
          (input)="onEditorInput($event)"
        ></div>
      </div>
      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeCommentModal()">Cancel</button>
        <button class="btn-save" (click)="saveComment()">Save</button>
      </div>
    </div>
  </div>
</div>
